import React from 'react';
import { BlockButton } from '@plone/volto-slate/editor/ui';
import { blockTagDeserializer } from '@plone/volto-slate/editor/deserialize';
import { insertToolbarButtons } from 'design-comuni-plone-theme/config/Slate/utils';
import hrSVG from 'rer-theme/icons/hr.svg';

export default function install(config) {
  const { slate } = config.settings;

  slate.buttons.hr = (props) => (
    <BlockButton
      title="Linea orizzontale"
      format="hr"
      // allowedChildren={config.settings.slate.allowedHeadlineElements}
      icon={hrSVG}
      //      data-isblock={true}
      {...props}
    />
  );

  slate.elements.hr = ({ children }) => (
    <>
      {children}
      <hr />
    </>
  );
  //slate.htmlTagsToSlate.HR = blockTagDeserializer('hr');
  //aggiungo il bottone HR alla toolbar, dopo blockquote
  insertToolbarButtons(['separator', 'hr'], 'blockquote', slate);

  return config;
}
